export default (axios, baseURL) => async () => {
  const url = `/v2/users/logout/internal`;
  const axiosConfig = {
    method: 'POST',
    baseURL,
    url,
    skipAuthLogout: true
  };
  try {
    const axiosResponse = await axios(axiosConfig);
    return axiosResponse.data;
  } catch (apiErr) {
    throw new Error('Failed to logout user');
  }
};
